









import { defineComponent, ref, Ref } from '@vue/composition-api'
import { TcModal } from '@telia/shared-ui-components'
import { Modal } from '@/types/common.types'

export default defineComponent({
  components: {
    TcModal
  },
  props: {
    closeButtonColor: {
      type: String,
      default: 'purple'
    }
  },
  setup () {
    const tcModal: Ref<Modal> = ref({} as Modal)

    const adjustBodyCss = () => {
    //its needed because overlay body is jumping very far to right when modal is open, style attribute is removed once modal is closed
      document.body.style.width = '100%'
      document.body.style.height = 'auto'
    }

    const showModal = () => {
      tcModal.value.showModal()
      adjustBodyCss()
    }

    const hideModal = () => {
      tcModal.value.hideModal()
    }

    return {
      tcModal,
      showModal,
      hideModal
    }
  }
})
